import { useFocusEffect } from "@react-navigation/native";
import { useCallback, useEffect, useRef, useState } from "react";
import { AppState } from "react-native";

let globalKey = 0;

export const useNewFetchKeyOnNav = (otherFetchKey?: string | number) => {
  const [fetchKey, setFetchKey] = useState(0);

  useFocusEffect(
    useCallback(() => {
      globalKey = (globalKey + 1) % Number.MAX_SAFE_INTEGER;
      setFetchKey(globalKey);
    }, [])
  );

  const appState = useRef(AppState.currentState);

  useEffect(() => {
    const subscription = AppState.addEventListener("change", (nextAppState) => {
      if (
        appState.current.match(/inactive|background/) &&
        nextAppState === "active"
      ) {
        globalKey = (globalKey + 1) % Number.MAX_SAFE_INTEGER;

        setFetchKey(globalKey);
      }

      appState.current = nextAppState;
    });

    return () => {
      subscription.remove();
    };
  }, []);

  return fetchKey + "" + (otherFetchKey ? otherFetchKey + "" : "");
};
